import React from 'react';
import logoSrc from '../assets/guiretal-logo.jpg';

/**
 * Single source of truth for the GUIRETAL brand mark.
 *
 * Renders just the visual — the parent still lays out the "GUIRETAL"
 * wordmark next to it if needed. Any future logo swap only touches this file.
 *
 * Props:
 *   size    — pixel dimensions (square). Defaults to 36 (matches the nav slot).
 *   rounded — Tailwind rounding class. Defaults to `rounded-lg`.
 */
export default function BrandLogo({ size = 36, rounded = 'rounded-lg', className = '' }) {
    return (
        <img
            src={logoSrc}
            alt="Logo GUIRETAL"
            width={size}
            height={size}
            style={{ width: size, height: size }}
            className={`${rounded} object-cover shrink-0 ${className}`}
            data-testid="brand-logo"
        />
    );
}
